import {
  ClockIcon,
  Flex,
  StarFilledIcon,
  Typography,
} from '@iheartjane/reefer';

import type { StoreViewModel } from '@jane/bloom/viewModels/store';

type StoreBannerProps = {
  isStoreClosed: boolean;
  loyaltyPoints?: number;
  pinnedStore: StoreViewModel;
};

export function StoreBanner({
  isStoreClosed = false,
  loyaltyPoints = 0,
  pinnedStore,
}: StoreBannerProps) {
  if (!isStoreClosed && loyaltyPoints === 0) {
    return <></>;
  }

  let bannerText = '';

  if (isStoreClosed) {
    const isDeliveryOnly = pinnedStore.delivery && !pinnedStore.pickup;
    if (
      pinnedStore.nextAvailableOpeningTime &&
      pinnedStore.allow_off_hours_ordering
    ) {
      if (isDeliveryOnly && pinnedStore.nextAvailableClosingTime) {
        bannerText = `Order now for delivery between ${pinnedStore.nextAvailableOpeningTime} - ${pinnedStore.nextAvailableClosingTime}.`;
      } else {
        bannerText = `This location is closed until ${pinnedStore.nextAvailableOpeningTime}. Pre-order now for when we open`;
        bannerText += loyaltyPoints > 0 ? '. ' : '!';
      }
    } else if (pinnedStore.nextAvailableOpeningTime) {
      bannerText = `This location is closed for ordering until ${pinnedStore.nextAvailableOpeningTime}.`;
    } else {
      bannerText = 'This location is closed.';
    }
  }

  return (
    <Flex
      flexWrap="wrap"
      alignItems="center"
      justifyContent="center"
      p={12}
      background="primary"
    >
      {isStoreClosed && <ClockIcon mr={8} size="sm" color="text-inverse" />}
      <Typography variant="body-bold" color="text-inverse">
        {bannerText}
      </Typography>
      {loyaltyPoints > 0 && (
        <>
          <StarFilledIcon mx={8} size="sm" color="text-inverse" />
          <Typography variant="body-bold" color="text-inverse">
            You have {loyaltyPoints} points
            {isStoreClosed ? '.' : ' · Redeem on your next order'}
          </Typography>
        </>
      )}
    </Flex>
  );
}
